/** `5400` → `1h 30m 0s`. Used wherever a duration is shown next to a file. */
export function formatDuration(seconds: number): string {
  const total = Math.round(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
}

/**
 * `13320` → `3h 42m`, `1080` → `18m`, `45` → `<1m`.
 *
 * Seconds are deliberately dropped: this is for balances and file lengths the user reads at a
 * glance ("Transcription remaining: 3h 42m"), where a ticking seconds digit reads as noise.
 */
export function formatDurationCompact(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  // Round to whole minutes first, so 3599s reads as `1h` rather than `59m`/`60m`.
  const totalMinutes = Math.round(total / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    return `${minutes}m`;
  }
  return total > 0 ? '<1m' : '0m';
}

/** `1536` → `1.5 KB`. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }

  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }

  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[unitIndex]}`;
}
